import { MasterBusinessCustomer } from "./master-business-customer";
import { MasterCustomerRechargeRenew } from "./master-customer-recharge-renew";
import { MasterCustomerVehicle } from "./master-customer-vehicle";

export class MasterCustomer {

  constructor() {
  }

  CUSTOMER_ID: number;
  BUSINESSGROUP_ID: number;
  CUSTOMER_NAME: string;
  CUSTOMERGROUP_ID: number;
  SURNAME: string;
  ADDRESS: string;
  CITY?: string;
  ZIPCODE?: string;
  COUNTRY?: string;
  PHONE_NO?: string;
  EMAIL_ID?: string;
  REMARKS: string;
  ORGANISATION_NAME: string;
  VALIDITY_FROM: string;
  VALIDITY_TO: string;
  PROFILE_ID: number;
  ACTIVE: boolean;

  NO_SUBJECT: boolean;
  RECHARGE_RENEW_SALE_AMOUNT: number;
  RECHARGE_RENEW_CREDITED_AMOUNT: number;
  RECHARGE_DISCOUNT_ID: number;
  RECHARGE_RENEW_FROM: string;
  RECHARGE_RENEW_TO: string;
  RECHARGE_RENEW_RECEIPT: boolean;
  RECHARGE_RENEW_FISCAL_RECEIPT: boolean;


  masterBusinessCustomer: MasterBusinessCustomer;
  MASTER_CUSTOMERS_VEHICLE_DTLs: MasterCustomerVehicle[];
  MASTER_CUSTOMERS_RECHARGE_RENEWs: MasterCustomerRechargeRenew[];

  ADMINISTRATIVE_SALE_PRICE: number;
  PAYTYPE_ID: number;
  ACTIVE_INACTIVE_REASON: string;
  ACTIVE_INACTIVE_BY_OPERATOR: number;

  ENTRY_USER: number;
}
